import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PaymentPage.css";

export default function PaymentPage() {
	const location = useLocation();
	const navigate = useNavigate();
	const { amount, enrollmentData } = location.state || {};

	// Protect the route - redirect if accessed directly
	useEffect(() => {
		if (!amount || !enrollmentData) {
			// Redirect to enrollment page if accessed directly
			navigate("/enrollement", { replace: true });
		}
	}, [amount, enrollmentData, navigate]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [enrollmentData]);

	// Show nothing while redirecting
	if (!amount || !enrollmentData) {
		return null;
	}

	const upiId = "9359118747@ptsbi";
	const merchantName = "Soham Wani";
	const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
		merchantName
	)}&am=${amount}&cu=INR&tn=${encodeURIComponent(
		`SimplyWebDev Course Payment - ${enrollmentData.name}`
	)}`;
	const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
		upiUrl
	)}`;

	const handleWhatsAppShare = () => {
		const message = `Hi! I've completed payment for SimplyWebDev courses.\n\nDetails:\nName: ${
			enrollmentData.name
		}\nEmail: ${
			enrollmentData.email
		}\nCourses: ${enrollmentData.selected_courses.join(
			", "
		)}\nAmount Paid: ₹${amount}\n\nPlease confirm my enrollment.`;

		window.open(
			`https://wa.me/919359118747?text=${encodeURIComponent(message)}`,
			"_blank"
		);
	};

	return (
		<div className="payment-page">
			<div className="payment-container">
				{/* Header */}
				<div className="payment-header">
					<img
						src="/logo.svg"
						alt="SimplyWebDev Logo"
						className="payment-logo"
					/>
					<h1 className="payment-title">Complete Your Payment</h1>
					<p className="payment-amount">Amount: ₹{amount}</p>
				</div>

				{/* QR Code Section */}
				<div className="payment-qr-section">
					<h2 className="section-title-pay">Scan QR Code to Pay</h2>
					<div className="qr-code-wrapper">
						<img src={qrCodeUrl} alt="UPI QR Code" className="qr-code" />
					</div>
					<p className="qr-instruction">
						Open any UPI app and scan this QR code
					</p>
				</div>

				<div className="payment-divider">
					<span>OR</span>
				</div>

				{/* Manual UPI Section */}
				<div className="payment-manual-section">
					<h2 className="section-title-pay">Pay Manually via UPI</h2>
					<div className="upi-details">
						<div className="upi-detail-item">
							<span className="upi-label">UPI ID:</span>
							<div className="upi-value-box">
								<span className="upi-value">{upiId}</span>
								<button
									className="copy-btn"
									onClick={() => {
										navigator.clipboard.writeText(upiId);
										alert("UPI ID copied!");
									}}
								>
									Copy
								</button>
							</div>
						</div>
						<div className="upi-detail-item">
							<span className="upi-label">Name:</span>
							<span className="upi-value">{merchantName}</span>
						</div>
						<div className="upi-detail-item">
							<span className="upi-label">Amount:</span>
							<span className="upi-value highlight">₹{amount}</span>
						</div>
					</div>
				</div>

				{/* Instructions */}
				<div className="payment-instructions">
					<h2 className="section-title-pay">📋 How to Pay</h2>
					<ol className="instruction-list">
						<li>Open your UPI app (Google Pay, PhonePe, Paytm, etc.)</li>
						<li>Scan the QR code above OR enter UPI ID manually: {upiId}</li>
						<li>Enter amount: ₹{amount}</li>
						<li>Complete the payment</li>
						<li>Take a screenshot of the payment confirmation</li>
						<li>Click the button below to send screenshot via WhatsApp</li>
					</ol>
				</div>

				{/* WhatsApp Button */}
				<button className="whatsapp-btn" onClick={handleWhatsAppShare}>
					<img
						src="/whatsapp-logo.svg"
						alt="WhatsApp"
						className="whatsapp-icon"
					/>
					Send Payment Confirmation
				</button>

				{/* What Happens Next */}
				<div className="payment-next-steps">
					<h2 className="section-title-pay">✨ What Happens Next?</h2>
					<div className="next-steps-grid">
						<div className="step-card">
							<div className="step-number">1</div>
							<h3>Payment Verification</h3>
							<p>
								We'll verify your payment within 30 minutes during business
								hours
							</p>
						</div>
						<div className="step-card">
							<div className="step-number">2</div>
							<h3>Enrollment Confirmation</h3>
							<p>
								You'll receive a confirmation email with your enrollment details
							</p>
						</div>
						<div className="step-card">
							<div className="step-number">3</div>
							<h3>Offer Letter</h3>
							<p>Your official offer letter will be sent to your email</p>
						</div>
						<div className="step-card">
							<div className="step-number">4</div>
							<h3>Course Access</h3>
							<p>
								Get instant access to course materials and join our community
							</p>
						</div>
					</div>
				</div>

				{/* Support */}
				<div className="payment-support">
					<p className="support-text">
						Need help? Contact us on WhatsApp: +91 9359118747
					</p>
				</div>

				{/* Back Button */}
				<button className="back-btn" onClick={() => navigate("/enrollement")}>
					← Back to Enrollment
				</button>
			</div>
		</div>
	);
}
